const Steps = {
  LOGIN: 'email',
  NAME: 'name',
  MINISTRY_INFO: 'ministry_info',
  PHONE: 'phone',
  PHONE_VERIFICATION: 'phone_verification',
  PRICING_PAYWALL: 'pricing_paywall',
  CHECKOUT: 'checkout',
} as const;

const HUBSPOT_STEP_VIEW_EVENT_NAMES = {
  LOGIN: 'email',
  NAME: 'name',
  MINISTRY_INFO: 'ministry_info',
  PHONE: 'phone',
  PHONE_VERIFICATION: 'phone_verification',
  PRICING_PAYWALL: 'pricing_paywall',
  CHECKOUT: 'checkout',
} as const;

export { Steps, HUBSPOT_STEP_VIEW_EVENT_NAMES };
